'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { ArrowRightIcon } from '@depop/web-ui-kit/Icons/ArrowRightIcon';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { type Breadcrumb } from '@/modules/breadcrumbs/types';

type BreadcrumbsProps = {
  items: Breadcrumb[];
  onBreadcrumbClick?: (label: string) => void;
  className?: string;
};

type BreadcrumbItemProps = Breadcrumb & {
  onClick?: (label: string) => void;
  showRightArrow?: boolean;
};

function BreadcrumbItem({
  label,
  link,
  onClick = () => null,
  showRightArrow = true,
}: BreadcrumbItemProps) {
  return (
    <li className={styles.breadcrumbItem}>
      {link ? (
        <ExtendedLink
          href={link}
          onClick={() => onClick(label)}
          className={styles.breadcrumbLink}
        >
          <Caption
            variant="lg-regular"
            className={clsx(styles.breadcrumbLabel, styles.breadcrumbLinkText)}
          >
            {label}
          </Caption>
        </ExtendedLink>
      ) : (
        <Caption
          variant="lg-regular"
          className={clsx(styles.breadcrumbLabel, styles.breadcrumbActiveLabel)}
        >
          {label}
        </Caption>
      )}
      {showRightArrow && <ArrowRightIcon size={12} />}
    </li>
  );
}

export function Breadcrumbs({
  items,
  onBreadcrumbClick = () => null,
  className,
}: BreadcrumbsProps) {
  const t = useTranslations('common');

  return (
    <div className={clsx(styles.breadcrumbsContainer, className)}>
      <div className={styles.breadcrumbsScrollableContainer}>
        <ul className={styles.breadcrumbsList}>
          <BreadcrumbItem label={t('Nav.Home')} link="/" />
          {items.map(({ label, link }, index) => {
            return (
              <BreadcrumbItem
                key={link || label}
                label={label}
                link={link}
                showRightArrow={index !== items.length - 1}
                onClick={onBreadcrumbClick}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}
